<template>
  <modal 
  name="datamanagement-modal"
  height="auto"
  width="90%"
  class="customSurveyModal"
  :scrollable="true"
  :adaptive="true"
  :min-width="350"
  @before-open="beforeOpen"
  @closed="closed">
    <div class="row7">
      <div class="inner">
        <header class="modalHeader flex flexAlignS mgReset">
          <p>데이터관리 상세</p>
          <button @click="onClickCancel"></button>
        </header>
        <div class="flex dataManagement">
          <div class="modalConLeft">
            <div class="left">
                <div class="top flex">
                  <p>구분</p>
                  <div class="tops">
                      <div class="tabMenu secItemMG">
                          <button class="accountTabBtn" :class="{active: currentTab===0}" v-on:click="setTabChange(0, 'ROLE_USER')">
                              개인 <span> {{personalCount}} </span>
                          </button>
                          <button class="accountTabBtn" :class="{active: currentTab===1}" v-on:click="setTabChange(1, 'ROLE_CORP')">
                              기업 <span> {{enterpriseCount}} </span>
                          </button>
                      </div>
                  </div>
                </div>
                <div class="bottom">
                  <div class="topContent flex">
                    <div class="left flex">
                      <p>총 <span>{{ personalCount + enterpriseCount }}</span>건</p>
                    </div>
                    <div>
                        <input type="text" class="searchInput smSize" v-model="searchText" @keyup.enter="onClickSearch"/>
                        <input type="button" value="검 색" class="searchBtn searchBtnCmmn" @click="onClickSearch"/>
                        <input type="button" value="검색초기화" class="searchResetBtn searchBtnCmmn" @click="onClickReset"/>
                        <input type="button" value="엑셀다운로드" class="excelBtn searchBtnCmmn" @click="makeExcelDownload"/>
                        <input type="button" value="통계" class="totalBtn searchBtnCmmn" @click="getSurveyStatics"/>
                    </div>
                  </div>
                  <div class="tableContainer">
                    <div class="sampleTemplate">
                          <b-table
                          ref="dataTable"
                          :fields="fields"
                          :items="getDatas"
                          :per-page="perPage"
                          :current-page="currentPage"
                          @row-clicked="onRowClicked"
                          hover
                          show-empty
                          empty-text="회원이 존재하지 않습니다.">
                            <template #emptyfiltered="scope">
                              <h4>{{ scope.emptyFilteredText }}</h4>
                            </template>
                          </b-table>

                          <b-pagination
                          v-model="currentPage"
                          :total-rows="totalCnt"
                          :per-page="perPage"
                          aria-controls="table">
                          </b-pagination>
                    </div>
                  </div>
                </div>
            </div>
          </div>
          <div v-if="isSurvey" class="modalConRight">
            <div class="topContents">
              <div class="surveyHeader">
                <p>상세보기</p>
              </div> 
              <div class="customerSurveyTitle">
                <p>
                  {{survey.title}}
                </p>
                <hr class="popupHr">
              </div>
            </div>
            <div class="introductionTxt">
                <h5>
                    {{ survey.introduction }}
                </h5>
                <section class="surveyArea lastChildNotMg">
                    <fieldset :disabled="true">
                      <component
                        v-for="item in survey.items"
                        :key="item.order"
                        :is="bindComponent(item)"
                        v-bind:item="item"
                        v-bind:status="status">
                      </component>
                    </fieldset>
                </section>
            </div>
          </div>
          <div v-if="isSurveyStatics" class="modalConRight">
            <div class="topContents">
              <div class="surveyHeader">
                <p>설문지 통계</p>
              </div> 
              <div class="customerSurveyTitle">
                <p>
                  {{survey.title}}
                  
                  <span>참여 : {{survey.surveyUserCount}}명</span>
                </p>
                <hr class="popupHr">
              </div>
            </div>
            <div class="introductionTxt">
                <h5>
                    {{ survey.introduction }}
                </h5>
                <section class="surveyArea lastChildNotMg">
                    <component
                      v-for="item in survey.items"
                      :key="item.order"
                      :is="bindStaticsComponent(item)"
                      v-bind:item="item"
                      v-bind:status="status">
                    </component>
                </section>
            </div>
          </div>
        </div> 
          
        <div class="modalFooterBtn btnBox addTopPd">
          <button @click="onClickCancel" class="redBtn">확인</button>
        </div>
        
      </div>
    </div>
  </modal>
</template>

<script>
import axios from '@/axios/axios'
import {mapState, mapMutations, mapActions} from 'vuex'
import * as surveyUtil from '@/utils/surveyUtil'
import Short from '../survey/customer/Short.vue'
import Multiple from '../survey/customer/Multiple.vue'
import Check from '../survey/customer/Check.vue'
import Linear from '../survey/customer/Linear.vue'
import ShortStatics from '../survey/statics/Short.vue'
import MultipleStatics from '../survey/statics/Multiple.vue'
import CheckStatics from '../survey/statics/Check.vue'
import LinearStatics from '../survey/statics/Linear.vue'
export default {
  name: 'ModalDataManagement',
  components:{
    Short,
    Multiple,
    Check,
    Linear
  },
  props:[
    'surveyIdx',
    'isSubmited'
  ],
  data(){
    return{
      modalResult: false,
      isSurveyStatics : false,
      isSurvey : false,
      currentTab: 0,
      searchText: "",
      personalCount: 0,
      enterpriseCount: 0,
      perPage: 10,
      currentPage: 1,
      roleName : "ROLE_USER",
      totalCnt: 0,
      selectMode: 'multi',
      selected: [],
      sortBy: 'IDX',
      sortDesc: false,
			fields: [
				{
					// virtual column
					key: 'ROWNUM',
					label: 'No',
					class: 'text-center'
				},
				{
					// virtual column
					key: 'ID',
					label: '아이디',
					isActive: true,
					class: 'statusOn text-center'
				},
				{
					key: 'NAME',
					label: '이름',
					class: 'text-center'
				},
				{
					key: 'REGDATE',
					label: '설문 등록 일시',
					class: 'text-center'
				}
			],
			detailSurveyIdx: null, // 등록: null, 수정: survey idx
    }
  },
  computed:{
    ...mapState('auth',[
      'user'
    ]),
    ...mapState('survey',[
      'survey'
    ]),
    status(){
      return surveyUtil.getStatus(this.survey.startDate, this.survey.endDate)
    }
  },
  mounted(){
    this.show()
  },
  methods:{
    ...mapMutations('survey', [
      'resetSurvey'
    ]),
    ...mapActions('survey', [
      'requestDetail',
      'requestSurveyStatics'
    ]),
    onRowClicked(item){
      this.isSurveyStatics = false;
      this.isSurvey = true;

      let surveyIdx = item.SURVEY_IDX;
      let userIdx = item.USER_IDX;
      this.requestDetail({
        surveyIdx: surveyIdx,
        userIdx: userIdx
      })
      .catch(() => {
        this.$alert('알림', '데이터를 가져올 수 없습니다.');
      })
    },
    onClickHead(/*selected*/) {
      this.$refs.dataTable.selectAllRows();
    },
    onSelectRow(items){
		this.selected = items;
	},
    show(){
      this.$modal.show('datamanagement-modal');
    },
    hide(){
      this.$modal.hide('datamanagement-modal');
    },
    beforeOpen(){
      this.resetSurvey();
      this.isSurveyStatics = false;
      this.isSurvey = false;
    },
    onClickSearch(){
      this.$refs.dataTable.refresh();
    },
    onClickReset(){
      this.searchText = "";
      this.onClickSearch();
    },
    closed(){
      this.$emit('modal-closed', this.$options.name, {result: this.modalResult})
    },
    bindComponent(item){
      switch(item.type){
        case 'SHORT':
          return Short
        case 'MULTIPLE':
          return Multiple
        case 'CHECK':
          return Check
        case 'LINEAR':
          return Linear
        default:
          return null
      }
    },
    bindStaticsComponent(item){
      switch(item.type){
        case 'SHORT':
          return ShortStatics
        case 'MULTIPLE':
          return MultipleStatics
        case 'CHECK':
          return CheckStatics
        case 'LINEAR':
          return LinearStatics
        default:
          return null
      }
    },
    onClickCancel(){
      this.hide() 
    },
    setTabChange(currentTab, roleName){
        this.currentTab = currentTab;
        this.roleName = roleName;

        this.$refs.dataTable.refresh();
    },
    getDatas(){
      return axios
          .post('/api/admin/data/getList', null,  { params: {
            currentPage: this.currentPage,
            perPage: this.perPage,
            sortBy: this.sortBy,
            sortDesc: this.sortDesc,
            searchText : this.searchText,
            roleName : this.roleName,
            surveyIdx : this.surveyIdx
          }})
          .then(response => {
            const items = response.data.items;
            this.totalCnt = response.data.totalCnt;
            this.personalCount = response.data.personalCount;
            this.enterpriseCount = response.data.enterpriseCount;
            
            return items;
          })
          .catch(error => {
              console.log("error: "+error)
              return []
          })
    },
    getSurveyStatics(){
      this.isSurveyStatics = true;
      this.isSurvey = false;
      this.requestSurveyStatics({
        surveyIdx: this.surveyIdx
      })
      .catch(() => {
        this.$alert('알림', '설문지 통계를 가져올 수 없습니다.')
      })
    },
    makeExcelDownload(){
      var params = {
        searchText : this.searchText,
        roleName : this.roleName,
        surveyIdx : this.surveyIdx
      };

      axios.post('/api/admin/data/excel', params , { responseType: 'arraybuffer' })
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers["content-type"] }))
            const link = document.createElement("a")
            link.href = url
            link.download = "example.xlsx"
            link.click()
            window.URL.revokeObjectURL(url)
        })
        .catch(error => {
            console.log("error: "+error)
            return []
        });
    }
  }
}
</script>

<style scoped>
.secItemMG button.accountTabBtn {
    margin: 0 0 0 10px;
}
</style>

<style scoped lang="scss">
	.sampleTemplate ::v-deep {
		@import "~bootstrap/dist/css/bootstrap.min";
		@import "~bootstrap-vue/dist/bootstrap-vue.min";
	}
</style>